import React from "react";
import Text from "../../../common/typography/text";
import ProfileProviderIcon from "../../../icons/provider-profile-icon";
import Tags from "../../../common/tags";
import { useScreen } from "../../Utils/Screens";

const dummyProcedureDetails = [
  {
    CaseID: "891723NM",
    PatientCode: "ROHBAN",
    ApplicationDate: "MM/DD/YYY",
    ApplicationNumber: "2",
  },
];

const ProcedureReview = ({
  providerName,
  applicationDate,
  firstNameInitials,
  lastNameInitials,
  CaseID,
  applicationNumber,
  procedureTagText,
  isPhone,
}) => {
  const procedureDetails = [
    {
      CaseID: CaseID,
      PatientCode: `${firstNameInitials}${lastNameInitials}`,
      ApplicationDate: applicationDate,
      ApplicationNumber: applicationNumber,
    },
  ];

  return (
    <>
      <Text variant="h1">Procedure Summary</Text>
      <div className="direct-order-review-detail-container">
        <div className="direct-order-review-detail-child-container">
          <div className="direct-order-review-detail-text-container">
            <div className="direct-order-review-detail-title-text-container">
              <Text variant="bodyText" color="lightText">
                Provider’s Name
              </Text>
            </div>
            {providerName?.label && (
              <div className="direct-order-review-detail-content-text-container">
                <div
                  className="direct-order-review-detail-content-code-quality-container"
                  style={isPhone ? { flexDirection: "column" } : {}}
                >
                  <ProfileProviderIcon className="icon-container-lightText" />
                  <Text variant="bodyText" color="lightText">
                    {providerName?.label}
                  </Text>
                  <Tags
                    tagText={procedureTagText}
                    tagBackground="blueBackground"
                    textColor="primaryColor"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {procedureDetails.length > 0 && (
        <div className="direct-order-review-detail-container">
          {procedureDetails.map((detail) => {
            return (
              <>
                <div className="direct-order-review-detail-child-container">
                  <div className="direct-order-review-detail-text-container">
                    <div className="direct-order-review-detail-title-text-container">
                      <Text variant="bodyText" color="lightText">
                        Case ID
                      </Text>
                    </div>
                    <div className="direct-order-review-detail-content-text-container">
                      <div className="direct-order-review-detail-content-code-quality-container">
                        <Text variant="bodyTextBold">{detail.CaseID}</Text>
                      </div>
                    </div>
                  </div>
                  <div className="direct-order-review-detail-text-container">
                    <div className="direct-order-review-detail-title-text-container">
                      <Text variant="bodyText" color="lightText">
                        Patient Code
                      </Text>
                    </div>
                    <div className="direct-order-review-detail-content-text-container">
                      <div className="direct-order-review-detail-content-code-quality-container">
                        <Text variant="bodyTextBold">{detail.PatientCode}</Text>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="direct-order-review-detail-child-container">
                  <div className="direct-order-review-detail-text-container">
                    <div className="direct-order-review-detail-title-text-container">
                      <Text variant="bodyText" color="lightText">
                        Application Date
                      </Text>
                    </div>
                    <div className="direct-order-review-detail-content-text-container">
                      <div className="direct-order-review-detail-content-code-quality-container">
                        <Text variant="bodyText">
                          {detail.ApplicationDate?.format("MM/DD/YYYY")}
                        </Text>
                      </div>
                    </div>
                  </div>
                  <div className="direct-order-review-detail-text-container">
                    <div className="direct-order-review-detail-title-text-container">
                      <Text variant="bodyText" color="lightText">
                        Application #
                      </Text>
                    </div>
                    <div className="direct-order-review-detail-content-text-container">
                      <div className="direct-order-review-detail-content-code-quality-container">
                        <Text variant="bodyText">
                          {detail.ApplicationNumber}
                        </Text>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </div>
      )}
    </>
  );
};

export default ProcedureReview;
